import { createSlice } from '@reduxjs/toolkit'

export const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        msg: '',
        status: false,
        type: '',
    },
    reducers: {
        setAlert: (state, action) => {
            state.msg = action.payload.msg;
            state.type = action.payload.type;
            state.status = true;
        },
        unsetAlert: (state) => {
            state.msg = '';
            state.type = '';
            state.status = false;
        }
    }
})

// Action creators are generated for each case reducer function
export const { setAlert, unsetAlert } = alertSlice.actions

export default alertSlice.reducer